export class Company {
  id: number;
  name: string;
  nameChart: string;
  salary: number;
  vacationDays: number | null;
  hiringTypeId: number;
  salaryAnualized: number;
  netSalary: number;
  totalTaxes: number;
  benefits: {};
  taxes: {};

  constructor(id) {
    this.id = id;
    this.name = this.generateRandomVacancieName();
    this.nameChart = this.name;
    this.salary = 0;
    this.netSalary = 0;
    this.totalTaxes = 0;
    this.vacationDays = 0;
    this.hiringTypeId = this.getRandomHiringType();
    this.benefits = {};
    this.taxes = {};
  }

  generateRandomVacancieName () {
    return `${this.getRandomFromList(this.positions)} @ ${this.capitalizeString(this.reverseString(this.getRandomFromList(this.companies)))}`;
  }
  getRandomFromList(list) {
    return list[Math.floor(Math.random()*list.length)]
  }

  reverseString(str) {
    return str.split("").reverse().join("");
  }

  capitalizeString(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  getRandomHiringType() {
    const min = Math.ceil(1);
    const max = Math.floor(2);
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  positions = [
    'UX designer',
    'Data engineer',
    'Frontend developer',
    'Backend developer',
    'AWS architect',
    'Devops',
    'Linux engineer',
  ]

  companies = [
    'google',
    'meta',
    'apple',
    'rappi',
    'uber',
    'amazon',
    'microsoft',
  ]
}
